import { render, staticRenderFns } from "./Newday.vue?vue&type=template&id=dd25adc0&lang=pug"
import script from "./Newday.vue?vue&type=script&lang=js"
export * from "./Newday.vue?vue&type=script&lang=js"
import style0 from "./Newday.vue?vue&type=style&index=0&id=dd25adc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports